import { Dialog } from '@mui/material';
import { RedirectBox } from '@portals/core/src/components/RedirectBox/RedirectBox';
import { DefaultSparkasseAssignmentForm } from '@portals/forms/src/forms/DefaultSparkasseAssignmentForm/DefaultSparkasseAssignmentForm';
import { useSPKCookie } from '@portals/forms/src/hooks/useSPKCookie/useSPKCookie';
import React, { useCallback, useMemo, useState } from 'react';

import { LinkThematischerLink } from '../../../../models';
import { useServiceBoxContext } from '../../../contexts/service-box';
import { useSparkassenAssignmentForm } from '../../../contexts/sparkasse-assignment-form';
import { useThematicLink } from '../../../hooks/useThematicLink';
import { getRedirectTimeout } from '../../../utils/thematischerLink';

export const SparkasseAssignmentFormModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState(null);
  const [bankSelected, setBankSelected] = useState<boolean>(false);
  const { bankName, bankCode } = useSPKCookie();
  const sparkasseKnown = typeof bankCode === 'string' && bankCode.length > 0;
  const timeout = useMemo(
    () =>
      getRedirectTimeout(
        {
          __component: 'link.thematischer-link',
          description: target?.description,
        } as LinkThematischerLink,
        bankCode
      ),
    [target, bankCode]
  );

  const { resolveLink, findForm } = useSparkassenAssignmentForm();
  const handleRedirect = useCallback(
    () => resolveLink(target?.key, target?.description, bankCode),
    [target, bankCode, resolveLink]
  );
  const { open: serviceBoxOpen } = useServiceBoxContext();
  const handleClose = useCallback(() => {
    setOpen(false);
    setTarget(null);
    setBankSelected(false);
  }, []);
  const handleBankSelected = useCallback(() => setBankSelected(true), []);

  useThematicLink((key, description) => {
    const form = findForm(key, description);
    if (!form && !serviceBoxOpen) {
      setOpen(true);
      setTarget({
        key,
        description,
      });
      if (sparkasseKnown) {
        setBankSelected(true);
      }
    }
  });

  return (
    <Dialog open={open} onClose={handleClose}>
      {target && bankSelected && <RedirectBox bankName={bankName} redirect={handleRedirect} timeout={timeout} />}
      {target && !bankSelected && <DefaultSparkasseAssignmentForm onSelectBank={handleBankSelected} />}
    </Dialog>
  );
};
